.fineprint {
	margin-bottom: calc(var(--size-2) + var(--size-5) * -1);
	font-size: var(--text-legal);
	color: var(--color-text-silent);
}

.loading {
	display: flex;
	justify-content: center;
}

.error {
	color: var(--color-error-text);

	&:empty {
		display: none;
	}
}

.signupTokenBanner {
	display: flex;
	text-align: center;
	justify-content: center;
	padding: var(--size-5) var(--size-7);
	color: var(--blue-100);
	background-color: var(--color-primary);
	font-weight: 500;

	&[data-expired="true"] {
		color: var(--red-100);
		background-color: var(--color-error-text);
	}
}
